/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BulkDeleteRequest } from '../models/BulkDeleteRequest';
import type { CampaignCreate } from '../models/CampaignCreate';
import type { CampaignMetricsResponse } from '../models/CampaignMetricsResponse';
import type { CampaignMonitoringResponse } from '../models/CampaignMonitoringResponse';
import type { CampaignResponse } from '../models/CampaignResponse';
import type { CampaignUpdate } from '../models/CampaignUpdate';
import type { ContactCreate } from '../models/ContactCreate';
import type { ContactResponse } from '../models/ContactResponse';
import type { ContactStateResponse } from '../models/ContactStateResponse';
import type { ContactUpdate } from '../models/ContactUpdate';
import type { HumanInputRequest } from '../models/HumanInputRequest';
import type { HumanInputResponse } from '../models/HumanInputResponse';
import type { PaginatedMessageHistoryResponse } from '../models/PaginatedMessageHistoryResponse';
import type { PromptCreate } from '../models/PromptCreate';
import type { PromptResponse } from '../models/PromptResponse';
import type { PromptUpdate } from '../models/PromptUpdate';
import type { TaskResponse } from '../models/TaskResponse';
import type { TaskUpdate } from '../models/TaskUpdate';
import type { WebhookEventResponse } from '../models/WebhookEventResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminApiService {
    /**
     * Get Tasks
     * @param contactId
     * @param campaignId
     * @param status
     * @param taskType
     * @param limit
     * @param offset
     * @returns TaskResponse Successful Response
     * @throws ApiError
     */
    public static getTasksApiAdminTasksGet(
        contactId?: (string | null),
        campaignId?: (string | null),
        status?: (string | null),
        taskType?: (string | null),
        limit: number = 100,
        offset?: number,
    ): CancelablePromise<Array<TaskResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/tasks',
            query: {
                'contact_id': contactId,
                'campaign_id': campaignId,
                'status': status,
                'task_type': taskType,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Task
     * @param taskId
     * @returns TaskResponse Successful Response
     * @throws ApiError
     */
    public static getTaskApiAdminTasksTaskIdGet(
        taskId: string,
    ): CancelablePromise<TaskResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/tasks/{task_id}',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Task
     * @param taskId
     * @param requestBody
     * @returns TaskResponse Successful Response
     * @throws ApiError
     */
    public static updateTaskApiAdminTasksTaskIdPatch(
        taskId: string,
        requestBody: TaskUpdate,
    ): CancelablePromise<TaskResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/admin/tasks/{task_id}',
            path: {
                'task_id': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Task
     * @param taskId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteTaskApiAdminTasksTaskIdDelete(
        taskId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/tasks/{task_id}',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Contacts
     * @param email
     * @param phone
     * @param campaignId
     * @param requiresHumanInput
     * @param limit
     * @param offset
     * @returns ContactResponse Successful Response
     * @throws ApiError
     */
    public static getContactsApiAdminContactsGet(
        email?: (string | null),
        phone?: (string | null),
        campaignId?: (string | null),
        requiresHumanInput?: (boolean | null),
        limit: number = 100,
        offset?: number,
    ): CancelablePromise<Array<ContactResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/contacts',
            query: {
                'email': email,
                'phone': phone,
                'campaign_id': campaignId,
                'requires_human_input': requiresHumanInput,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Contact
     * @param requestBody
     * @returns ContactResponse Successful Response
     * @throws ApiError
     */
    public static createContactApiAdminContactsPost(
        requestBody: ContactCreate,
    ): CancelablePromise<ContactResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/contacts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Contact
     * @param contactId
     * @returns ContactResponse Successful Response
     * @throws ApiError
     */
    public static getContactApiAdminContactsContactIdGet(
        contactId: string,
    ): CancelablePromise<ContactResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/contacts/{contact_id}',
            path: {
                'contact_id': contactId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Contact
     * @param contactId
     * @param requestBody
     * @returns ContactResponse Successful Response
     * @throws ApiError
     */
    public static updateContactApiAdminContactsContactIdPatch(
        contactId: string,
        requestBody: ContactUpdate,
    ): CancelablePromise<ContactResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/admin/contacts/{contact_id}',
            path: {
                'contact_id': contactId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Contact
     * Delete a contact and optionally all related data.
     * @param contactId
     * @param cascade Delete all related data (messages, tasks, events)
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteContactApiAdminContactsContactIdDelete(
        contactId: string,
        cascade: boolean = true,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/contacts/{contact_id}',
            path: {
                'contact_id': contactId,
            },
            query: {
                'cascade': cascade,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Clean Contact Data
     * Clean all related data for a contact without deleting the contact itself.
     * @param contactId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static cleanContactDataApiAdminContactsContactIdCleanPost(
        contactId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/contacts/{contact_id}/clean',
            path: {
                'contact_id': contactId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Contact By Email
     * Delete a contact by email address and optionally all related data.
     * @param email
     * @param cascade Delete all related data (messages, tasks, events)
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteContactByEmailApiAdminContactsByEmailEmailDelete(
        email: string,
        cascade: boolean = true,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/contacts/by-email/{email}',
            path: {
                'email': email,
            },
            query: {
                'cascade': cascade,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bulk Delete Contacts
     * Bulk delete contacts and optionally all related data.
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static bulkDeleteContactsApiAdminContactsBulkDeletePost(
        requestBody: BulkDeleteRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/contacts/bulk-delete',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Message History
     * Get paginated message history for a contact.
     * @param contactId
     * @param limit
     * @param offset
     * @param channel
     * @returns PaginatedMessageHistoryResponse Successful Response
     * @throws ApiError
     */
    public static getMessageHistoryApiAdminContactsContactIdMessageHistoryGet(
        contactId: string,
        limit: number = 50,
        offset?: number,
        channel?: (string | null),
    ): CancelablePromise<PaginatedMessageHistoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/contacts/{contact_id}/message-history',
            path: {
                'contact_id': contactId,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'channel': channel,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Contact State
     * Get all contact states for a given contact.
     * @param contactId
     * @returns ContactStateResponse Successful Response
     * @throws ApiError
     */
    public static getContactStateApiAdminContactsContactIdStateGet(
        contactId: string,
    ): CancelablePromise<Array<ContactStateResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/contacts/{contact_id}/state',
            path: {
                'contact_id': contactId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Test Messages
     * @param contactId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static addTestMessagesApiAdminContactsContactIdTestMessagesPost(
        contactId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/contacts/{contact_id}/test-messages',
            path: {
                'contact_id': contactId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Webhook Events
     * @param contactId
     * @param campaignId
     * @param eventType
     * @param processed
     * @param limit
     * @param offset
     * @returns WebhookEventResponse Successful Response
     * @throws ApiError
     */
    public static getWebhookEventsApiAdminWebhookEventsGet(
        contactId?: (string | null),
        campaignId?: (string | null),
        eventType?: (string | null),
        processed?: (string | null),
        limit: number = 100,
        offset?: number,
    ): CancelablePromise<Array<WebhookEventResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/webhook-events',
            query: {
                'contact_id': contactId,
                'campaign_id': campaignId,
                'event_type': eventType,
                'processed': processed,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Prompts
     * @param promptType
     * @param campaignId
     * @param isActive
     * @param limit
     * @param offset
     * @returns PromptResponse Successful Response
     * @throws ApiError
     */
    public static getPromptsApiAdminPromptsGet(
        promptType?: (string | null),
        campaignId?: (string | null),
        isActive?: (string | null),
        limit: number = 100,
        offset?: number,
    ): CancelablePromise<Array<PromptResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/prompts',
            query: {
                'prompt_type': promptType,
                'campaign_id': campaignId,
                'is_active': isActive,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Prompt
     * @param requestBody
     * @returns PromptResponse Successful Response
     * @throws ApiError
     */
    public static createPromptApiAdminPromptsPost(
        requestBody: PromptCreate,
    ): CancelablePromise<PromptResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/prompts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Prompt
     * @param promptId
     * @returns PromptResponse Successful Response
     * @throws ApiError
     */
    public static getPromptApiAdminPromptsPromptIdGet(
        promptId: string,
    ): CancelablePromise<PromptResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/prompts/{prompt_id}',
            path: {
                'prompt_id': promptId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Prompt
     * @param promptId
     * @param requestBody
     * @returns PromptResponse Successful Response
     * @throws ApiError
     */
    public static updatePromptApiAdminPromptsPromptIdPatch(
        promptId: string,
        requestBody: PromptUpdate,
    ): CancelablePromise<PromptResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/admin/prompts/{prompt_id}',
            path: {
                'prompt_id': promptId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Prompt
     * @param promptId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deletePromptApiAdminPromptsPromptIdDelete(
        promptId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/prompts/{prompt_id}',
            path: {
                'prompt_id': promptId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Clean Demo Data
     * @returns any Successful Response
     * @throws ApiError
     */
    public static cleanDemoDataApiAdminCleanDemoPost(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/clean-demo',
        });
    }
    /**
     * Get Stats
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getStatsApiAdminStatsGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/stats',
        });
    }
    /**
     * Start Campaign Admin
     * Start a campaign for a contact (admin endpoint).
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static startCampaignAdminApiAdminCampaignsStartPost(
        requestBody: Record<string, any>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/campaigns/start',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Campaigns
     * @param status
     * @param limit
     * @param offset
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static getCampaignsApiAdminCampaignsGet(
        status?: (string | null),
        limit: number = 100,
        offset?: number,
    ): CancelablePromise<Array<CampaignResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/campaigns',
            query: {
                'status': status,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Campaign
     * Create a new campaign.
     * @param requestBody
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static createCampaignApiAdminCampaignsPost(
        requestBody: CampaignCreate,
    ): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/campaigns',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Campaign
     * Update an existing campaign.
     * @param campaignId
     * @param requestBody
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static updateCampaignApiAdminCampaignsCampaignIdPatch(
        campaignId: string,
        requestBody: CampaignUpdate,
    ): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/admin/campaigns/{campaign_id}',
            path: {
                'campaign_id': campaignId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Campaign
     * Delete a campaign. Contacts will be reassigned to default campaign.
     * @param campaignId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteCampaignApiAdminCampaignsCampaignIdDelete(
        campaignId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/campaigns/{campaign_id}',
            path: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Campaign Monitoring
     * Get campaign monitoring data showing all contacts with their next tasks and state history.
     * @param campaignId
     * @returns CampaignMonitoringResponse Successful Response
     * @throws ApiError
     */
    public static getCampaignMonitoringApiAdminCampaignMonitoringGet(
        campaignId?: (string | null),
    ): CancelablePromise<Array<CampaignMonitoringResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/campaign-monitoring',
            query: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Campaign Metrics
     * Get campaign metrics including appointments booked.
     *
     * Appointments booked counts unique users who have at least one successful
     * ScheduleInviteWorkflow execution.
     * @param campaignId Filter by campaign ID
     * @returns CampaignMetricsResponse Successful Response
     * @throws ApiError
     */
    public static getCampaignMetricsApiAdminCampaignMetricsGet(
        campaignId?: (string | null),
    ): CancelablePromise<CampaignMetricsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/campaign-metrics',
            query: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Submit Human Input
     * Submit human representative input for a contact.
     *
     * This endpoint:
     * 1. Adds the message to message history
     * 2. Cancels all pending tasks for the contact
     * 3. Triggers orchestrator to make a new decision
     * 4. Processes the orchestrator response (schedules new tasks if needed)
     * @param requestBody
     * @returns HumanInputResponse Successful Response
     * @throws ApiError
     */
    public static submitHumanInputApiAdminHumanInputPost(
        requestBody: HumanInputRequest,
    ): CancelablePromise<HumanInputResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/human-input',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
